<template>
  <div>

    <Dialog :visible.sync="exibirModalNovo" header="Mudança de Horário" :modal="true" :style="{width: '55vw'}" @hide="fecharModal">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label>Data início</label>							
                <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body" :disabled="bloquearDatas" :locale="localeCalendarBR"/>
            </div>  
            <div class="p-field p-col-12 p-md-6">
                <label>Data final</label>							
                <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body" :disabled="bloquearDatas" :locale="localeCalendarBR"/>
            </div>            
        </div>
        <div class="p-fluid p-formgrid p-grid">               
            <div class="p-field p-col-12 p-md-12">
                <label>Justificativa</label>							
                <Dropdown v-model="idJustificativaSelecionada" :options="justificativas" 
                                optionLabel="descricao" optionValue="id" placeholder="Selecione" appendTo="body" dataKey="id"/>
            </div>               
        </div>         
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-2 p-md-2">
                <label>1ª Entrada</label>
                <InputText v-model="horarioFlexivel.entrada1" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('entrada1')" autocomplete="off"/>
            </div> 
            <div class="p-field p-col-2 p-md-2">
                <label>1ª Saída</label>
                <InputText v-model="horarioFlexivel.saida1" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('saida1')" autocomplete="off"/>
            </div> 
            <div class="p-field p-col-2 p-md-2">
                <label>2ª Entrada</label>
                <InputText v-model="horarioFlexivel.entrada2" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('entrada2')" autocomplete="off"/>
            </div> 
            <div class="p-field p-col-2 p-md-2">
                <label>2ª Saída</label>
                <InputText v-model="horarioFlexivel.saida2" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('saida2')" autocomplete="off"/>
            </div> 
            <div class="p-field p-col-2 p-md-2">
                <label>3ª Entrada</label>
                <InputText v-model="horarioFlexivel.entrada3" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('entrada3')" autocomplete="off"/>
            </div> 
            <div class="p-field p-col-2 p-md-2">
                <label>3ª Saída</label>
                <InputText v-model="horarioFlexivel.saida3" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('saida3')" autocomplete="off"/>
            </div>           
        </div>        				
        <template #footer>
            <div class="p-d-flex p-jc-between">
                <h6 class="p-text-bold">Marcações do dia {{ dataPonto }}</h6>
                <div>
                    <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
                    <Button label="Salvar" icon="pi pi-check" @click="executarAcao('SALVAR')" v-if="horarioFlexivel.id == null"/>
                    <Button label="Excluir" class="p-button-danger" icon="pi pi-times" @click="executarAcao('EXCLUIR')" v-if="horarioFlexivel.id != null"/>
                </div>                              
            </div>            
        </template>        
    </Dialog>
  </div>
</template>

<script>
import ControlePontoService from '@/service/ControlePontoService';
import HorarioFlexivel from '@/model/HorarioFlexivel';
import { exibirMensagem, exibirMensagemSis, formatarEtradaHora, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    props: {
        callback: Function,
    },
    data() {
        return {
            bloquearDatas: false,
            horarioFlexivel: new HorarioFlexivel(),
            idJustificativaSelecionada: null,
            dataPonto: null,
            exibirModalNovo: false,
            dataInicio: new Date(),
            dataFinal: new Date(),           
            justificativas: [],
            requisicao: {},
            localeCalendarBR: localeCalendarBR,
            eventoSelecionado: '',
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        processar(req) {   
            this.eventoSelecionado = '';
            this.requisicao = {...req};   
            this.dataPonto = this.formatarStringData(req.dataPonto);
            this.dataInicio = this.formatarStringData(req.dataPonto);                
            this.dataFinal = this.formatarStringData(req.dataPonto);                  
            this.controlePontoService.buscarMudancaHorario(req)
            .then(resp => {          
                this.horarioFlexivel = resp.data.horarioFlexivel;                
                if(typeof this.horarioFlexivel === 'undefined') {
                    this.bloquearDatas = false;
                    this.horarioFlexivel = new HorarioFlexivel();
                } else {
                    this.bloquearDatas = true;
                    this.idJustificativaSelecionada = resp.data.justificativa.id;
                }                
                this.justificativas = resp.data.justificativas;     
                this.exibirModalNovo = true;
            })
            .catch(erro => {exibirMensagem(this, erro)});            
        },  
        executarAcao(acao) {
            if(acao == 'SALVAR') {                
                this.salvar();
            } else {
                this.excluir();
            }
        },   
        salvar() {      
            if(!this.idJustificativaSelecionada) {
                exibirMensagemSis(this, 'Selecione uma justificativa', true);
                return;
            }
            let justificativaSeleiconada = null;         
            this.justificativas.forEach(justificativa => {               
                if(justificativa.id == this.idJustificativaSelecionada) {
                    justificativaSeleiconada = justificativa;
                }
            });   
            let req = {...this.requisicao};
            req['dataInicio'] = this.formatarData(this.dataInicio);
            req['dataFinal'] = this.formatarData(this.dataFinal);
            req['justificativa'] = {...justificativaSeleiconada};
            req['horarioFlexivel'] = {...this.horarioFlexivel};
            this.controlePontoService.salvaMudancaHorario(req)
            .then(resp => {   
                exibirMensagem(this, resp);		
                this.callback(req.dataInicio, req.dataFinal);
                this.fecharModal();
            })
            .catch(erro => {   
                exibirMensagem(this, erro)
            });  
        },
        excluir() {             
            let req = {...this.requisicao};
            req['dataInicio'] = this.formatarData(this.dataInicio);
            req['dataFinal'] = this.formatarData(this.dataFinal); 
            this.controlePontoService.excluirMudancaHorario(req)
            .then(resp => {   
                exibirMensagem(this, resp);		
                this.callback(req.dataInicio, req.dataFinal);
                this.fecharModal();
            })
            .catch(erro => {
                exibirMensagem(this, erro)
            });  
        },
        limparEntradaHoraInvalida(campo) {
            if(this.horarioFlexivel[campo] == null) {
                return;
            }
            let regex = /[0-2][0-9]:[0-5][0-9]/g;
            if(!this.horarioFlexivel[campo].match(regex)) {
                this.horarioFlexivel[campo] = '';
            }
        },
        validarEntraHora(event) {
            formatarEtradaHora(event);
        },   
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},    
        formatarStringData(data) {
            if(!data || data instanceof Date) {
                return '';
            } 
            let partes = data.split('-');
            return partes[2] + '/' + partes[1] + '/' + partes[0];
        },     
        fecharModal() {
            this.bloquearDatas = false;
            this.idJustificativaSelecionada = null;
            this.exibirModalNovo = false;
            this.requisicao = {};
            this.justificativas = [];       
            this.horarioFlexivel = new HorarioFlexivel();     
        }
    },
    created() {
        this.controlePontoService = new ControlePontoService();
    },
}
</script>

<style>

</style>